import { useModalStore } from '@/shared/lib';
import { UserProfileModal } from '../ui/UserProfileModal';

export function useUserProfileDialog() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openUserProfileDialog = () => {
    showDialogComponent({
      component: (
        <UserProfileModal onOpenProfileDialog={openUserProfileDialog} />
      ),
      className:
        'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto bg-secondary-bg border-0 flex',
      onClose: closeDialog,
    });
  };

  return { openUserProfileDialog };
}
